export default __webpack_public_path__ + "static/2_28-f7d613cb807df4917b13915dcc55d83e.png";